<script setup lang="ts">
    import { MessagingWindow } from '@deegital/vue-trustup-io-messaging';
    import BaseModel from '~~/app/base/models/BaseModel';

    const { authed, tenant } = useAuthStore();
    const { trustupMessagingAppKey, trustupIoMessagingUrl } = useRuntimeConfig().public;

    defineProps<{
        model: typeof BaseModel;
        modelPrefix?: string;
        containerClassName?: string;
    }>();
</script>

<template>
    <div
        class="h-full overflow-y-auto messaging-window-container nice-scrollbar"
        :class="containerClassName ?? ''"
    >
        <MessagingWindow
            :is-discussion="true"
            :app-key="trustupMessagingAppKey"
            :model-type="modelPrefix || model.prefix"
            :model-id="model.getId()"
            :user-id="Number(authed?.getId())"
            :account-id="tenant?.getId()"
            :user-first-name="authed?.firstName"
            :user-last-name="authed?.lastName"
            :user-avatar="authed?.avatar"
            is-full
            :messaging-url="trustupIoMessagingUrl"
        />
    </div>
</template>

<style>
    .messaging-window-container {
        display: flex;
        flex-direction: column;
        position: relative;
        overflow: hidden !important;
    }

    .messaging-window-container::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 20px;
        background: linear-gradient(to bottom, white, white 50%, transparent);
        z-index: 5;
        pointer-events: none;
    }

    .messaging-window-container > * {
        flex: 1;
        min-height: 0;
        height: 100%;
    }

    /* Scroll area leaves space for the input */
    .messaging-window-container #scrollable {
        padding-top: 40px;
        height: calc(100% - 70px) !important;
        position: static !important;
    }

    /* Message list fills the scroll area for justify-end */
    .messaging-window-container .flex.flex-col.gap-3 {
        min-height: 100% !important;
        height: auto !important;
    }

    /* Input: taken out of scroll, pinned at bottom */
    .messaging-window-container .sticky.bottom-0 {
        position: absolute !important;
        bottom: 0 !important;
        left: 0 !important;
        right: 0 !important;
        z-index: 10 !important;
    }

    .messaging-window-container button {
        @apply bg-branding-brand-yellow;
    }

    .messaging-window-container button:has(.fa-microphone),
    .messaging-window-container button:has(.fa-paperclip),
    .messaging-window-container button:has(.fa-image) {
        @apply bg-transparent;
    }
</style>
